import { IDependentValues } from '../../../@types/workspaceTypes';

export const formatValue = (
  value: any,
  { dependentValues, decimals }: { dependentValues: Partial<IDependentValues>; decimals: number }
) => {
  const infinityLimit = dependentValues.options?.infinityLimit;
  const format = dependentValues.options?.format;

  let formattedValue: string | number = +value;

  if (isNaN(formattedValue)) {
    formattedValue = value;
  } else if (infinityLimit && formattedValue >= infinityLimit) {
    formattedValue = '∞';
  } else if (format?.formatNumber) {
    //If we have a valid numeric value & a formatNumber function, let that function handle it.
    //(For example, to add a currency symbol in the correct place - Can't use 'prefix' on NumericFormatter because it would go before the minus symbol).
    formattedValue = format.formatNumber(formattedValue as number, { dependentValues, decimals });
  } else {
    formattedValue = (formattedValue as number).toFixed(decimals);
  }

  if (format && format.thousandSeparator) {
    formattedValue = formattedValue.toString().replace(/(?<!\.\d+)\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (dependentValues.options?.suppressTrailingZeros) {
    formattedValue = removeTrailingZeros(formattedValue as number);
  }

  return formattedValue;
};

const removeTrailingZeros = (numeric: number | string) => {
  let str = numeric.toString();
  while (str.endsWith('0')) {
    str = str.slice(0, -1);
  }
  return parseFloat(str);
};
